import initCarousel from "components/jiffy/header-promo-carousel/header-promo-carousel";

document.addEventListener("DOMContentLoaded", initCarousel);
